import { LazyLoadEvent } from 'primeng';
import { IEmailTemplate, IEmailTemplateParameter } from '../../interfaces/email-template';
import { IEmailTemplateParameterFilter } from '../../interfaces/email-template-filter';
import { IPageResult } from '../../interfaces/page-result';
import { EmailTemplateParameterService } from '../../services';
import { Router, ActivatedRoute } from '@angular/router';
import { EmailTemplateService } from '../../services';
import { Component, OnInit, ViewChild } from '@angular/core';

@Component({
  selector: 'email-template-form',
  templateUrl: './email-template-form.component.html',
})

// Component for displaying email template form for creating or updating email template
export class EmailTemplateFormComponent implements OnInit {
  public _emailTemplate: IEmailTemplate = <IEmailTemplate>{};
  public _title: string;
  public _checkCodeEndpoint: string;
  public _parameters: IEmailTemplateParameter[];

  public dataTableSettings: any = {
    isPaginator: true,
  };

  public page: IPageResult<IEmailTemplateParameter> = {
    items: [],
    total: 0,
  };

  public quillModules: any = {
    toolbar: [
      [{ header: [] }, { font: [] }],
      ['bold', 'italic', 'underline'],
      [{ color: [] }, { background: [] }],

      [{ list: 'ordered' }, { list: 'bullet' }, { align: [] }],

      ['link', 'image'],

      ['clean'],
    ],
    imageResize: {
      modules: ['Resize', 'DisplaySize'],
    },
  };

  @ViewChild('message') message: any;

  constructor(
    private emailTemplateService: EmailTemplateService,
    private emailTemplateParameterService: EmailTemplateParameterService,
    private router: Router,
    private route: ActivatedRoute,
  ) {
    route.params.subscribe((p) => {
      this._emailTemplate.id = +p['id'];
    });
  }

  ngOnInit() {
    this._checkCodeEndpoint = this.emailTemplateService.checkCodeUrl();

    //sends get request to get email template details if it exists.
    //If email template does not exist it navigates to email templates page
    if (this._emailTemplate.id) {
      this._title = 'Edit Email Template';
      this.emailTemplateService
        .get(this._emailTemplate.id)
        .then((data) => {
          this._emailTemplate = data;
        })
        .catch((data) => {
          this.router.navigate(['/app/email-templates']);
        });
    } else {
      this._title = 'Add Email Template';
    }
  }

  getDefaultFilter() {
    return <IEmailTemplateParameterFilter>{
      first: 0,
      rows: 10,
      sortField: 'Title',
      sortOrder: 1,
      filters: {
        title: {},
      },
    };
  }

  load(filterCommand: IEmailTemplateParameterFilter) {
    // send get reguest for getting email template parameters
    this.emailTemplateParameterService.getPage(filterCommand).then((result) => {
      this.page.items = result.items;
      this.page.total = result.total;
    });
  }

  onGridLazyLoad(event: LazyLoadEvent) {
    var filter = this.getDefaultFilter();
    filter.first = event.first;
    filter.rows = event.rows;
    if (event.sortField) filter.sortField = event.sortField;
    filter.sortOrder = event.sortOrder;
    this.load(filter);
  }

  save() {
    //sends put request (UPDATE) if email template exists and navigates to email templates page
    if (this._emailTemplate.id) {
      this.emailTemplateService.update(this._emailTemplate.id, this._emailTemplate).then((data) => {
        this.router.navigate(['/app/email-templates']);
      });
    }
    //sends post request (CREATE) if email template does not exist and navigates to email templates page
    else {
      this.emailTemplateService.create(this._emailTemplate).then((data) => {
        this.router.navigate(['/app/email-templates']);
      });
    }
  }
}
